"use client";

import { createContext } from "react";
import type { SnapshotInOf } from "mobx-keystone";
import type { InvoiceModel } from "../mobx/core/invoice/model.invoice";
import type { MeterModel } from "../mobx/core/meter/model.meter";
import type { MeterReadingModel } from "../mobx/core/meter/model.meter-reading";
import type { NudgeModel } from "../mobx/core/nudge/model.nudge";
import type OrganizationModel from "../mobx/core/organization/model.organization";
import type {
  AutoPayEnrollmentModel,
  PaymentMethodModel,
  PaymentModel,
} from "../mobx/core/payment/model.payment";
import type { ServiceAccountModel } from "../mobx/core/service-account/model.service-account";
import type UserModel from "../mobx/core/user/model.user";
import type { UserContactModel } from "../mobx/core/user/model.user";

export interface DataPromiseMap {
  invoices?: Promise<SnapshotInOf<InvoiceModel>[]>;
  serviceAccounts?: Promise<SnapshotInOf<ServiceAccountModel>[]>;
  payments?: Promise<SnapshotInOf<PaymentModel>[]>;
  paymentMethods?: Promise<SnapshotInOf<PaymentMethodModel>[]>;
  meters?: Promise<SnapshotInOf<MeterModel>[]>;
  meterReadings?: Promise<SnapshotInOf<MeterReadingModel>[]>;
  notifications?: Promise<SnapshotInOf<NudgeModel>[]>;
  autoPayEnrollments?: Promise<SnapshotInOf<AutoPayEnrollmentModel>[]>;
  user?: Promise<SnapshotInOf<UserModel> | undefined>;
  organization?: Promise<SnapshotInOf<OrganizationModel>>;
  contacts?: Promise<SnapshotInOf<UserContactModel>[]>;
}

export const DataPromiseContext = createContext<DataPromiseMap>({});
